/* globals urls, koisCustomerProfile, validate, moment, RSVP, ProfileHelper */
/* exported ProfileHelper */

(function($, ProfileHelper) {

	// Disable submitting form when pressing the enter key. Submission & validation will be handled via AJAX
	$('form#registration').keypress( function( e ) {
		var code = e.keyCode || e.which;
		if( code === 13 ) {
			e.preventDefault();
			return false;
		}
	});

	// Add basic date parsing tp validate.js
	validate.extend(validate.validators.datetime, {
		// The value is guaranteed not to be null or undefined but otherwise it
		// could be anything.
		parse: function(value, options) {
			return +moment.utc(value);
		},
		// Input is a unix timestamp
		format: function(value, options) {
			var format = options.dateOnly ? "YYYY-MM-DD" : "YYYY-MM-DD hh:mm:ss";
			return moment.utc(value).format(format);
		}
	});

	// Add RSVP to validate.js to allow for async validation using Promises
	validate.Promise = RSVP.Promise;
	// Add custom async validator for checking if a username and email combination exist in the WP database
	validate.validators.userAsyncValidator = function(value) {
		return new validate.Promise(function(resolve, reject) {
			// User AJAX to call the custom WP REST API route
			$.ajax({
				url: '/wp-json/kois-user/exists',
				data: { u: value.username, e: value.email }
			})
			// 200 response means they're both available
			.done(function() {
				resolve();
			})
			// Anything else is a failure, and the results will be parsed to display to the user
			.fail(function(jqXHR){
				var objResponse = $.parseJSON(jqXHR.responseText);
				reject(objResponse);
			});
		});
	};

	var regFormAlreadyProcessing = false;

	// Registration validation for steps 1 & 2
	$('.step-continue').on('click', function(e){

		e.preventDefault();
	
		if(!regFormAlreadyProcessing) {
			regFormAlreadyProcessing = true;

			// Find the current step
			var step = $(this).data('step');
			var objValidationResult;
	
			// Remove any existing error message(s) and error classes from fields
			clearRegistrationErrors(step);
	
			// Perform validation based on the current step
			switch(step){
				case 'one':
					objValidationResult = validateRegistrationStepOne(step);
					break;
	
				case 'two':
					objValidationResult = validateRegistrationStepTwo(step);
					objValidationResult = (!objValidationResult ? checkFormForHtmlTags() : objValidationResult);
					break;
			}
	
			// Validation passed, show the next step
			if(!objValidationResult){
				if(step === 'one') {
					showNextStep(step);
				} else {
					createCustomer();
				}
			}
			// objValidationResult exists and isn't a Promise. Validation has failed, show the relevant errors
			else if(objValidationResult && !objValidationResult.isPromise){
				showRegistrationErrors(step, objValidationResult);
			}
			else{
				// We got a Promise back. Wait for async validation to finish
			}
		}
	});

	/* GLOBAL VALIDATION */
	// Check all fields for HTMl tags
	function checkFormForHtmlTags(){
		var form = document.querySelector("form#registration");
		var objCustomerData = validate.collectFormValues(form);
		var objValidationResult = ProfileHelper.checkForTags(objCustomerData);
		return objValidationResult;
	}

	/* STEP ONE */

	// Validate step 1 of the registration form
	function validateRegistrationStepOne(step){

		//	get language
		var languageCode = $('meta[property="og:locale"]').attr('content');

		// Set up validation values and contraints
		var values = {
			UserName: $('#user-id').val(),
			Email: $('#user-email').val(),
			Password: $('#p-word').val(),
			PasswordConfirmation: $('#re-p-word').val()
		};
		var constraints = {
			UserName: {
				presence: {
					message: i18nError(languageCode, 'UsernameBlank')
				},
			  	length: {
					maximum: 41,
					tooLong: i18nError(languageCode, 'UsernameTooLong', {max: 41})
				},
				format: {
					// User ID can only contain letters and numbers
					pattern: '^[a-zA-Z0-9]+',
					message: i18nError(languageCode, 'UsernameFormat')
				}
			},
			Email: {
				presence: {
					message: i18nError(languageCode, 'EmailBlank')
				},
				email: {
					message: i18nError(languageCode, 'EmailFormat')
				}
			},
			Password: {
				presence: {
					message: i18nError(languageCode, 'PasswordBlank')
				},
				format: {
					pattern: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/, // Password must be at least 8 characters, including at least 1 lowecase letter, 1 uppercase letter, and 1 digit
					message: i18nError(languageCode, 'PasswordFormat')
				}
			},
			PasswordConfirmation: {
				equality: {
					attribute: 'Password',
					message: i18nError(languageCode, 'PasswordConfirmationNotEqual')
				},
				presence: {
					message: i18nError(languageCode, 'PasswordConfirmationBlank')
				}
			}
		};

		// Perform validation
		var objValidationResult = validate(values, constraints);

		// If basic validation passed, perform async validation to make sure the username and email are still available
		if(!objValidationResult){
			objValidationResult = checkUsernameAndEmailAvailability(step);
		}

		// Return the validation result (or Promise, in the case of checkUsernameAndEmailAvailability)
		return objValidationResult;
	}

	// Perform an asynchronous validation of the user's chosen username and email to make sure they're available
	function checkUsernameAndEmailAvailability(step){
		// On success, show the next step
		var success = function(){ showNextStep(step); };
		// On error, parse the resulting WP REST API response body to display relevant info for the impacted field(s)
		var error = function(error) {
			var objValidationError = {};
			if(error.code === 'both_exist'){
				objValidationError.UserName = ['This username is already taken'];
				objValidationError.Email = ['This email is already taken'];
			}
			else if(error.code === 'email_exists'){
				objValidationError.Email = ['This email is already taken'];
			}
			else if(error.code === 'username_exists'){
				objValidationError.UserName = ['This username is already taken'];
			}
			else{
				objValidationError.UserName = [error.message];
				objValidationError.Email = [error.message];
			}
			showRegistrationErrors(step, objValidationError);
		};

		// Set up validation values and contraints
		var asyncValues = {
			usernameAndEmail: {
				username: $('#user-id').val(),
				email: $('#user-email').val()
			}
		};
		var asyncConstraints = {
			usernameAndEmail: {userAsyncValidator: true}
		};

		// Perform async validation, passing success and error handlers to the resulting Promise to be run once it has been settled
		var promise = validate.async(asyncValues, asyncConstraints).then(success, error);

		// Wrap promise in an object with a simple flag so Promise objects are easily distinguishable from validation error objects
		return {isPromise: true, promise: promise};
	}

	/* STEP TWO */

	// Validate step 2 of the registration form
	function validateRegistrationStepTwo(){
		//	get language
		var languageCode = $('meta[property="og:locale"]').attr('content');

		// Set up validation values and contraints
		var values = {
			Title: $('#title').val(),
			DoctorSpecialty: $('#prof-specialty').val(),
			FirstName: $('#f-name-00').val(),
			LastName: $('#l-name-00').val(),
			PreferredName: $('#pre-name').val()||null,
			CustomerWebsite: $('#office-website').val()||null,
			OfficeContactEmail: $('#office-email').val()||null,
			OfficePhone: $('#office-phone').val(),
			OfficeAddress1: $('#office-address-00').val(),
			OfficeAddressCity: $('#office-city-00').val(),
			OfficeAddressCountry: $('#office-country-00').val(),
			OfficeAddressState: $('#office-state-prov-00').val(),
			OfficeAddressRegion: $('#office-region-00').val(),
			OfficeAddressZip: $('#office-zip-00').val(),
			// Conditionally-required fields
			checkBillingAddressValues: !$('#billing-box').prop('checked'),
			BillingAddressFirstName: $('#f-name-01').val(),
			BillingAddressLastName: $('#l-name-01').val(),
			BillingAddress1: $('#office-address-01').val(),
			BillingAddressCity: $('#office-city-01').val(),
			BillingAddressCountry: $('#office-country-01').val(),
			BillingAddressState: $('#office-state-prov-01').val(),
			BillingAddressRegion: $('#billing-region-01').val(),
			BillingAddressZip: $('#office-zip-01').val(),
			checkShippingAddressValues: !$('#shipping-box').prop('checked'),
			ShippingAddressFirstName: $('#f-name-02').val(),
			ShippingAddressLastName: $('#l-name-02').val(),
			ShippingAddress1: $('#office-address-02').val(),
			ShippingAddressCity: $('#office-city-02').val(),
			ShippingAddressCountry: $('#office-country-02').val(),
			ShippingAddressState: $('#office-state-prov-02').val(),
			ShippingAddressRegion: $('#shipping-region-01').val(),
			ShippingAddressZip: $('#office-zip-02').val(),
			PrivacyPolicy: $('#privacy-policy').prop('checked').toString()
		};

		var constraints = {
			Title:{ 
				presence: {
					message: i18nError(languageCode, 'TitleBlank')
				} 
			},
			DoctorSpecialty: {
				presence: {
					message: i18nError(languageCode, 'DoctorSpecialtyBlank')
				}
			},
			FirstName:{
				presence: {
					message: i18nError(languageCode, 'FirstNameBlank')
				},
				length: {
		      		maximum: 25,
		      		tooLong: i18nError(languageCode, 'FirstNameTooLong', {max: 25})
				},
				format: {
					pattern: /^(?=.*[A-Z])(?=.*[a-z]).*$/gm,
					message: i18nError(languageCode, 'FirstNameFormat')
				}
			},
			LastName:{
				presence: {
					message: i18nError(languageCode, 'LastNameBlank')
				},
				length: {
		      		maximum: 25,
		      		tooLong: i18nError(languageCode, 'LastNameTooLong', {max: 25})
				},
				format: {
					pattern: /^(?=.*[A-Z])(?=.*[a-z]).*$/gm,
					message: i18nError(languageCode, 'LastNameFormat')
				}
			},
			PreferredName: {
				format: {
					pattern: /^(?=.*[A-Z])(?=.*[a-z]).*$/gm,
					message: i18nError(languageCode, 'PreferredNameFormat')
				}
			},
			CustomerWebsite: { 
				url: { 
					message: i18nError(languageCode, 'CustomerWebsiteFormat')
				}
			},
			OfficeContactEmail: { 
				email: { 
					message: i18nError(languageCode, 'OfficeContactEmailFormat')
				} 
			},
			OfficePhone: { 
				presence: { 
					message: i18nError(languageCode, 'OfficePhoneBlank')
				}  
			},
			OfficeAddress1: { 
				presence: { 
					message: i18nError(languageCode, 'OfficeAddress1Blank')
				}  
			},
			OfficeAddressCity: {
				presence: { 
					message: i18nError(languageCode, 'OfficeAddressCityBlank')
				},
				format: {
					pattern: /^(?=.*[A-Z])(?=.*[a-z]).*$/gm,
					message: i18nError(languageCode, 'OfficeAddressCityFormat')
				}
			},
			OfficeAddressCountry: { 
				presence: { 
					message: i18nError(languageCode, 'OfficeAddressCountryBlank')
				} 
			},
			OfficeAddressState: function(value, attributes, attr, options, constraints) {
				return !ProfileHelper.isUsOrCanada(attributes.OfficeAddressCountry) ? {} : {
					presence: { 
						message: i18nError(languageCode, 'OfficeAddressStateBlank')
					}
				};
			},
			OfficeAddressRegion: function(value, attributes, attr, options, constraints) {
				return ProfileHelper.isUsOrCanada(attributes.OfficeAddressCountry) ? {} : {
					presence: { 
						message: i18nError(languageCode, 'OfficeAddressRegionBlank')
					},
					format: {
						pattern: /^(?=.*[A-Z])(?=.*[a-z]).*$/gm,
						message: i18nError(languageCode, 'OfficeAddressRegionFormat')
					}
				};
			},
			OfficeAddressZip: { 
				presence: { 
					message: i18nError(languageCode, 'OfficeAddressZipBlank')
				} 
			},
			BillingAddressFirstName: function(value, attributes, attr, options, constraints) {
				return !attributes.checkBillingAddressValues ? {} : {
					presence: { 
						message: i18nError(languageCode, 'BillingAddressFirstNameBlank')
					},
					format: {
						pattern: /^(?=.*[A-Z])(?=.*[a-z]).*$/gm,
						message: i18nError(languageCode, 'BillingAddressFirstNameFormat')
					}
				};
			},
			BillingAddressLastName: function(value, attributes, attr, options, constraints) {
				return !attributes.checkBillingAddressValues ? {} : {
					presence: { 
						message: i18nError(languageCode, 'BillingAddressLastNameBlank')
					},
					format: {
						pattern: /^(?=.*[A-Z])(?=.*[a-z]).*$/gm,
						message: i18nError(languageCode, 'BillingAddressLastNameFormat')
					}
				};
			},
			BillingAddress1: function(value, attributes, attr, options, constraints) {
				return !attributes.checkBillingAddressValues ? {} : {
					presence: { 
						message: i18nError(languageCode, 'BillingAddress1Blank')
					}
				};
			},
			BillingAddressCity: function(value, attributes, attr, options, constraints) {
				return !attributes.checkBillingAddressValues ? {} : {
					presence: { 
						message: i18nError(languageCode, 'BillingAddressCityBlank')
					},
					format: {
						pattern: /^(?=.*[A-Z])(?=.*[a-z]).*$/gm,
						message: i18nError(languageCode, 'BillingAddressCityFormat')
					}
				};
			},
			BillingAddressCountry: function(value, attributes, attr, options, constraints) {
				return !attributes.checkBillingAddressValues ? {} : {
					presence: { 
						message: i18nError(languageCode, 'BillingAddressCountryBlank')
					}
				};
			},
			BillingAddressState: function(value, attributes, attr, options, constraints) {
				return !attributes.checkBillingAddressValues || !ProfileHelper.isUsOrCanada(attributes.BillingAddressCountry) ? {} : {
					presence: { 
						message: i18nError(languageCode, 'BillingAddressStateBlank')
					}
				};
			},
			BillingAddressRegion: function(value, attributes, attr, options, constraints) {
				return !attributes.checkBillingAddressValues || ProfileHelper.isUsOrCanada(attributes.BillingAddressCountry) ? {} : {
					presence: { 
						message: i18nError(languageCode, 'BillingAddressRegionBlank')
					},
					format: {
						pattern: /^(?=.*[A-Z])(?=.*[a-z]).*$/gm,
						message: i18nError(languageCode, 'BillingAddressRegionBlank')
					}
				};
			},
			BillingAddressZip: function(value, attributes, attr, options, constraints) {
				return !attributes.checkBillingAddressValues ? {} : {
					presence: { 
						message: i18nError(languageCode, 'BillingAddressZipBlank')
					}
				};
			},
			ShippingAddressFirstName: function(value, attributes, attr, options, constraints) {
				return !attributes.checkShippingAddressValues ? {} : {
					presence: { 
						message: i18nError(languageCode, 'ShippingAddressFirstNameBlank')
					},
					format: {
						pattern: /^(?=.*[A-Z])(?=.*[a-z]).*$/gm,
						message: i18nError(languageCode, 'ShippingAddressFirstNameFormat')
					}
				};
			},
			ShippingAddressLastName: function(value, attributes, attr, options, constraints) {
				return !attributes.checkShippingAddressValues ? {} : {
					presence: { 
						message: i18nError(languageCode, 'ShippingAddressLastNameBlank')
					},
					format: {
						pattern: /^(?=.*[A-Z])(?=.*[a-z]).*$/gm,
						message: i18nError(languageCode, 'ShippingAddressLastNameFormat')
					}
				};
			},
			ShippingAddress1: function(value, attributes, attr, options, constraints) {
				return !attributes.checkShippingAddressValues ? {} : {
					presence: { 
						message: i18nError(languageCode, 'ShippingAddress1Blank')
					}
				};
			},
			ShippingAddressCity: function(value, attributes, attr, options, constraints) {
				return !attributes.checkShippingAddressValues ? {} : {
					presence: { 
						message: i18nError(languageCode, 'ShippingAddressCityBlank')
					},
					format: {
						pattern: /^(?=.*[A-Z])(?=.*[a-z]).*$/gm,
						message: i18nError(languageCode, 'ShippingAddressCityFormat')
					}
				};
			},
			ShippingAddressCountry: function(value, attributes, attr, options, constraints) {
				return !attributes.checkShippingAddressValues ? {} : {
					presence: { 
						message: i18nError(languageCode, 'ShippingAddressCountryBlank')
					}
				};
			},
			ShippingAddressState: function(value, attributes, attr, options, constraints) {
				return !attributes.checkShippingAddressValues || !ProfileHelper.isUsOrCanada(attributes.ShippingAddressCountry) ? {} : {
					presence: { 
						message: i18nError(languageCode, 'ShippingAddressStateBlank')
					}
				};
			},
			ShippingAddressRegion: function(value, attributes, attr, options, constraints) {
				return !attributes.checkShippingAddressValues || ProfileHelper.isUsOrCanada(attributes.ShippingAddressCountry) ? {} : {
					presence: { 
						message: i18nError(languageCode, 'ShippingAddressRegionBlank')
					},
					format: {
						pattern: /^(?=.*[A-Z])(?=.*[a-z]).*$/gm,
						message: i18nError(languageCode, 'ShippingAddressRegionFormat')
					}
				};
			},
			ShippingAddressZip: function(value, attributes, attr, options, constraints) {
				return !attributes.checkShippingAddressValues ? {} : {
					presence: { 
						message: i18nError(languageCode, 'ShippingAddressZipBlank')
					}
				};
			},
			PrivacyPolicy: function(value, attributes, attr, options, constraints) {
				return {
					presence: true,
					format: {
						pattern: /^true$/gm,
						message: i18nError(languageCode, 'PrivacyPolicyUnaccepted')
					}
				};
			}
		};

		// Perform validation and return the result
		return validate(values, constraints);
	}

	// Submit data via ajax to attempt to register this customer
	function createCustomer(){
		var objCustomerData = buildRegistrationData();

		$('button.step-finish').prop('disabled', true).addClass('c-btn--disabled');

		// Make AJAX call to create this new customer
		$.ajax({
			method: "POST",
			url: urls.ajax,
			data: { action: 'create_new_customer', formData: objCustomerData }
		})
		.done(function( strResponse ) {
			var objResponse = $.parseJSON(strResponse);

			$('#registration-step-three .message-target').html(objResponse.message);

			$('button.step-finish').prop('disabled', false).removeClass('c-btn--disabled');

			regFormAlreadyProcessing = false;

			// If this is a success and we have a redirect URL, redirect the user there
			if(objResponse.success === true && objResponse.redirect_url){
				ProfileHelper.ignoreDataChanges = true;
				window.location = objResponse.redirect_url;
			}
			// Otherwise scroll to the top of the page so the user can see whatever message was returned
			else{
				window.scrollTo(0,0);
			}
		});
	}

	/* COMMON FUNCTIONALITY */

	// Shows the next step based on the current step
	function showNextStep(step){
		$('#registration-step-'+step+' .step-continue').parents('[id*="registration-step-"]').addClass('complete').removeClass('in-progress').next().addClass('in-progress');
		window.scrollTo(0,0);

		regFormAlreadyProcessing = false;
	}

	// Displays validation errors to the user based on the current step
	function showRegistrationErrors(step, objValidationResult){
		// Make AJAX call to render the twig message partial with a generic error message
		$.ajax({
			method: "POST",
			url: urls.ajax,
			data: { action: 'generate_registration_error' }
		})
		.done(function( strResponse ) {
			var objResponse = $.parseJSON(strResponse);

			// Add the generic error message to the top of this step, and scroll the window there
			if(objResponse.success){
				$('#registration-step-'+step+' .message-target').html(objResponse.message);
				window.scrollTo(0,0);
			}
			// Highlight fields and add error messages based on objValidationResult
			addFieldValidationErrorStylesAndMessages(objValidationResult);

			regFormAlreadyProcessing = false;
		});
	}

	// Add validation error messages for each education row, based on validation results
	function addFieldValidationErrorStylesAndMessages(objValidationResult){
		$.each(objValidationResult, function(key, value){
			var strErrorMessage = '<span class="validation-error">'+value[0]+'</span>';
			var el;
			switch(key){
				// Dropdowns have a div wrapped around them, so they need to be handed differently
				case 'Title':
				case 'OfficeAddressCountry':
				case 'OfficeAddressState':
				case 'BillingAddressCountry':
				case 'BillingAddressState':
				case 'ShippingAddressCountry':
				case 'ShippingAddressState':
				case 'DoctorSpecialty':
					el = $('select[name="'+key+'"]').parent('.selectbox-container');
					el.addClass('error');
					el.prevAll('label').addClass('error');
					el.after(strErrorMessage);
					break;
				// Radio buttons have error classes/messages applied to their "parent" label
				case 'SharePersonalInfo':
				case 'AlumniLookUpOption':
					el = $('input[name="'+key+'"]').prevAll('label.required');
					el.addClass('error');
					el.after(strErrorMessage);
					break;
				// Education Row(s) are handled separately
				case 'educationRows':
					ProfileHelper.addEducationRowErrors(value);
					break;
				case 'SpecialRequests':
					el = $('textarea[name="'+key+'"]');
					el.addClass('error');
					el.prevAll('label').addClass('error');
					el.after(strErrorMessage);
					break;
				// Normal inputs (e.g. text, email, password, etc...) have error class applied directly to input and label, and error message after the input
				default:
					el = $('input[name="'+key+'"]');
					el.addClass('error');
					el.prevAll('label').addClass('error');
					el.after(strErrorMessage);
					break;
			}
		});
	}

	// Remove validation errors from the form
	function clearRegistrationErrors(step){
		$('#registration-step-'+step+' .message-target').html('');
		// TODO: Clear field-specific errors once they are implemented
		$('.error').removeClass('error');
		$('span.validation-error').remove();
	}

	// Handler function for when a country dropdown's value is changed, to ensure the correct state/province or region field is displayed
	function changeStateField(objEvent){
		// Mapping of the various country field ids to their corresponding state/province and review field ids
		var objFieldIdMappings = {
			'office-country-00': {
				stateField: 'office-state-prov-00',
				regionField: 'office-region-00'
			},
			'office-country-01': {
				stateField: 'office-state-prov-01',
				regionField: 'billing-region-01'
			},
			'office-country-02': {
				stateField: 'office-state-prov-02',
				regionField: 'shipping-region-01'
			},
			'symposium-add-on-country': {
				stateField: 'symposium-add-on-state-prov',
				regionField: 'symposium-add-on-region'
			}
		};

		// Find the id of the field being chnaged
		var eventTargetId = objEvent.target.id;

		// If the field id being changed is in our mapping object, we need to show/hide some fields
		if(objFieldIdMappings[eventTargetId]){
			// Find the new value of the country dropdown
			var strCountryDropDownValue = $(this).val();

			// If that dropdown represents the US or Canada, show the associated state/prvince dropdown and hide the associated region field
			if(ProfileHelper.isUsOrCanada(strCountryDropDownValue)){
				$('#'+objFieldIdMappings[eventTargetId]['regionField']).addClass('hidden');
				$('#'+objFieldIdMappings[eventTargetId]['stateField']).parent('.selectbox-container').removeClass('hidden');
			}
			// Otherwise, hide the associated state/prvince dropdown and show the associated region field
			else{
				$('#'+objFieldIdMappings[eventTargetId]['stateField']).parent('.selectbox-container').addClass('hidden');
				$('#'+objFieldIdMappings[eventTargetId]['regionField']).removeClass('hidden');
			}

			// Remove any error classes/message for these fields now that the state changed
			var regionField = $('#'+objFieldIdMappings[eventTargetId]['regionField']);
			regionField.removeClass('error').prevAll('label').removeClass('error');
			regionField.nextAll('span.validation-error').remove();
			var stateField = $('#'+objFieldIdMappings[eventTargetId]['stateField']).parent('.selectbox-container');
			stateField.removeClass('error').prevAll('label').removeClass('error');
			stateField.nextAll('span.validation-error').remove();
		}
	}
	// Bind our handler function to change events on all country dropdowns
	$('select.country-dropdown, body.woocommerce-checkout select.country_to_state').change(changeStateField);

	// Helper function for when the specialty dropdown is changed, to hide/show additional fields as needed
	function showHideSpecialtyAdditionalFields(){
		var strSpecialtyDropDownValue = $(this).val();

		if(ProfileHelper.isSpecialtyWithAdditionalFields(strSpecialtyDropDownValue)){
			$('#specialty-university, #specialty-year-completed').parent().removeClass('hidden');
		}
		else{
			$('#specialty-university, #specialty-year-completed').parent().addClass('hidden');
		}
	}
	// Bind our handler function to change events on the specialty dropdown
	$('select#prof-specialty').change(showHideSpecialtyAdditionalFields);

	// Helper function for when the referral source dropdown is changed, to hide/show additional field as needed
	function showHideReferralSourceOtherDetailsField(){
		var strReferralSourceDropDownValue = $(this).val();

		if(strReferralSourceDropDownValue.toLowerCase() === 'other'){
			$('.referral-other').removeClass('hidden');
		}
		else{
			$('.referral-other').addClass('hidden');
		}
	}
	// Bind our handler function to change events on the referral source dropdown
	$('select#referral-type').change(showHideReferralSourceOtherDetailsField);

	// Helper function to build the data needed to create a new customer
	function buildRegistrationData(){
		var form = document.querySelector("form#registration");
		var objCustomerData = validate.collectFormValues(form);
		var arrCustomerEducationRows = ProfileHelper.getEducationRowData();

		var objRegistration = {
			password: $('#p-word').val(),
			customerData: objCustomerData,
			customerEducation: {
				customerEducationData: arrCustomerEducationRows
			},
			copyBillingAddressFromOffice: $('#billing-box').prop('checked'),
			copyShippingAddressFromOffice: $('#shipping-box').prop('checked')
		};

		return objRegistration;
	}

	// If we're on the register page, set up initial form data and set an onbeforeload event to prevent users from losing unsaved data
	if(ProfileHelper.page === 'register'){
		// Cache the initial state of the form data for later comparison
		ProfileHelper.setInitProfileData(buildRegistrationData());
		// Check if the profile data has changed before a user navigates away or refreshes the page. If it has, show them an alert.
		// NOTE: Chrome and FireFox won't show the text below, but both have sensible default messages.
		window.onbeforeunload = function() {
			if(ProfileHelper.dataHasChanged(buildRegistrationData())){
				return "You have unsaved data. Are you sure you want to navigate away?";
			}
		};
	}

	//	get a translated error message
	var i18nError = function(languageCode, phraseKey, data) {
		var translatedString =  translations[languageCode][phraseKey];

		for (var key in data) {
			translatedString = translatedString.replace('{'+key+'}', data[key]);
		}

		return translatedString;
	};

	//	translated error messages
	var translations = {
		en_US: {
			UsernameBlank: "can't be blank",
			UsernameFormat: "is invalid",
			UsernameTooLong: "cannot exceed {max} characters",
			EmailBlank: "can't be blank",
			EmailFormat: "is not a valid email",
			PasswordBlank: "can't be blank",
			PasswordFormat: "is invalid",
			PasswordConfirmationBlank: "can't be blank",
			PasswordConfirmationNotEqual: "is not equal to password",
			TitleBlank: "can't be blank",
			DoctorSpecialtyBlank: "can't be blank",
			FirstNameBlank: "can't be blank",
			FirstNameTooLong: "cannot exceed {max} characters",
			FirstNameFormat: "cannot be all upper or lower case",
			LastNameBlank: "can't be blank",
			LastNameTooLong: "cannot exceed {max} characters",
			LastNameFormat: "cannot be all upper or lower case",
			PreferredNameFormat: "cannot be all upper or lower case",
			CustomerWebsiteFormat: "link invalid. Please ensure you include http:// or https:// in the url.",
			OfficeContactEmailFormat: "is not a valid email",
			OfficePhoneBlank: "can't be blank",
			OfficeAddress1Blank: "can't be blank",
			OfficeAddressCityBlank: "can't be blank",
			OfficeAddressCityFormat: "cannot be all upper or lower case",
			OfficeAddressCountryBlank: "can't be blank",
			OfficeAddressStateBlank: "can't be blank",
			OfficeAddressRegionBlank: "can't be blank",
			OfficeAddressRegionFormat: "cannot be all upper or lower case",
			OfficeAddressZipBlank: "can't be blank",
			BillingAddressFirstNameBlank: "can't be blank",
			BillingAddressFirstNameFormat: "cannot be all upper or lower case",
			BillingAddressLastNameBlank: "can't be blank",
			BillingAddressLastNameFormat: "cannot be all upper or lower case",
			BillingAddress1Blank: "can't be blank",
			BillingAddressCityBlank: "can't be blank",
			BillingAddressCityFormat: "cannot be all upper or lower case",
			BillingAddressCountryBlank: "can't be blank",
			BillingAddressStateBlank: "can't be blank",
			BillingAddressRegionBlank: "can't be blank",
			BillingAddressRegionFormat: "cannot be all upper or lower case",
			BillingAddressZipBlank: "can't be blank",
			ShippingAddressFirstNameBlank: "can't be blank",
			ShippingAddressFirstNameFormat: "cannot be all upper or lower case",
			ShippingAddressLastNameBlank: "can't be blank",
			ShippingAddressLastNameFormat: "cannot be all upper or lower case",
			ShippingAddress1Blank: "can't be blank",
			ShippingAddressCityBlank: "can't be blank",
			ShippingAddressCityFormat: "cannot be all upper or lower case",
			ShippingAddressCountryBlank: "can't be blank",
			ShippingAddressStateBlank: "can't be blank",
			ShippingAddressRegionBlank: "can't be blank",
			ShippingAddressRegionFormat: "cannot be all upper or lower case",
			ShippingAddressZipBlank: "can't be blank",
			PrivacyPolicyUnaccepted: "must be accepted to continue"
		},
		fr: {
			UsernameBlank: "^Le nom d'utilisateur ne peut pas être vide",
			UsernameFormat: "^Nom d'utilisateur invalide",
			UsernameTooLong: "^Le nom d'utilisateur ne peut pas dépasser {max} caractères",
			EmailBlank: "^L'e-mail ne peut pas être vide",
			EmailFormat: "^L'e-mail n'est pas un e-mail valide",
			PasswordBlank: "^Le mot de passe ne peut pas être vide",
			PasswordFormat: "^Le mot de passe n'est pas valide",
			PasswordConfirmationBlank: "^La confirmation du mot de passe ne peut pas être vide",
			PasswordConfirmationNotEqual: "^La confirmation du mot de passe n'est pas égale au mot de passe",
			TitleBlank: "^Le titre ne peut pas être vide",
			DoctorSpecialtyBlank: "^La spécialité du médecin ne peut pas être vide",
			FirstNameBlank: "^Le prénom ne peut pas être vide",
			FirstNameTooLong: "^Le prénom ne peut pas dépasser {max} caractères",
			FirstNameFormat: "^Le prénom ne peut pas être entièrement en majuscules ou en minuscules",
			LastNameBlank: "^Le nom de famille ne peut pas être vide",
			LastNameTooLong: "^Le nom de famille ne peut pas dépasser {max} caractères",
			LastNameFormat: "^Le nom de famille ne peut pas être entièrement en majuscules ou en minuscules",
			PreferredNameFormat: "^Le nom préféré ne peut pas être entièrement en majuscules ou en minuscules",
			CustomerWebsiteFormat: "^Lien du site Web du client invalide. Veuillez vous assurer d'inclure http:// ou https:// dans l'url.",
			OfficeContactEmailFormat: "^L'e-mail de contact du bureau n'est pas un e-mail valide",
			OfficePhoneBlank: "^Le téléphone de bureau ne peut pas être vide",
			OfficeAddress1Blank: "^La ligne d'adresse du bureau 1 ne peut pas être vide",
			OfficeAddressCityBlank: "^La ville de l'adresse du bureau ne peut pas être vide",
			OfficeAddressCityFormat: "^La ville de l'adresse du bureau ne peut pas être entièrement en majuscules ou en minuscules",
			OfficeAddressCountryBlank: "^Le pays de l'adresse du bureau ne peut pas être vide",
			OfficeAddressStateBlank: "^L'état de l'adresse du bureau ne peut pas être vide",
			OfficeAddressRegionBlank: "^La région de l'adresse du bureau ne peut pas être vide",
			OfficeAddressRegionFormat: "^La région de l'adresse du bureau ne peut pas être entièrement en majuscules ou en minuscules",
			OfficeAddressZipBlank: "^Le code postal de l'adresse du bureau ne peut pas être vide",
			BillingAddressFirstNameBlank: "^Le prénom de l'adresse de facturation ne peut pas être vide",
			BillingAddressFirstNameFormat: "^Le prénom de l'adresse de facturation ne peut pas être entièrement en majuscules ou en minuscules",
			BillingAddressLastNameBlank: "^Le nom de famille de l'adresse de facturation ne peut pas être vide",
			BillingAddressLastNameFormat: "^Le nom de famille de l'adresse de facturation ne peut pas être entièrement en majuscules ou en minuscules",
			BillingAddress1Blank: "^La ligne d'adresse de facturation 1 ne peut pas être vide",
			BillingAddressCityBlank: "^La ville de l'adresse de facturation ne peut pas être vide",
			BillingAddressCityFormat: "^La ville de l'adresse de facturation ne peut pas être entièrement en majuscules ou en minuscules",
			BillingAddressCountryBlank: "^Le pays de l'adresse de facturation ne peut pas être vide",
			BillingAddressStateBlank: "^L'état de l'adresse de facturation ne peut pas être vide",
			BillingAddressRegionBlank: "^La région de l'adresse de facturation ne peut pas être vide",
			BillingAddressRegionFormat: "^La ville de l'adresse de facturation ne peut pas être entièrement en majuscules ou en minuscules",
			BillingAddressZipBlank: "^Le code postal de l'adresse de facturation ne peut pas être vide",
			ShippingAddressFirstNameBlank: "^Le prénom de l'adresse de livraison ne peut pas être vide",
			ShippingAddressFirstNameFormat: "^Le prénom de l'adresse de livraison ne peut pas être entièrement en majuscules ou en minuscules",
			ShippingAddressLastNameBlank: "^Le nom de l'adresse de livraison ne peut pas être vide",
			ShippingAddressLastNameFormat: "^Le nom de famille de l'adresse de livraison ne peut pas être entièrement en majuscules ou en minuscules",
			ShippingAddress1Blank: "^La ligne d'adresse de livraison 1 ne peut pas être vide",
			ShippingAddressCityBlank: "^La ville de l'adresse de livraison ne peut pas être vide",
			ShippingAddressCityFormat: "^La ville de l'adresse de livraison ne peut pas être entièrement en majuscules ou en minuscules",
			ShippingAddressCountryBlank: "^Le pays de l'adresse de livraison ne peut pas être vide",
			ShippingAddressStateBlank: "^L'état de l'adresse de livraison ne peut pas être vide",
			ShippingAddressRegionBlank: "^La région de l'adresse de livraison ne peut pas être vide",
			ShippingAddressRegionFormat: "^La ville de l'adresse de livraison ne peut pas être entièrement en majuscules ou en minuscules",
			ShippingAddressZipBlank: "^Le code postal de l'adresse de livraison ne peut pas être vide",
			PrivacyPolicyUnaccepted: "^La politique de confidentialité doit être acceptée pour continuer"
		},
		de: {
			UsernameBlank: "^Benutzername darf nicht leer sein",
			UsernameFormat: "^Benutzername ist ungültig",
			UsernameTooLong: "^Benutzername darf {max} Zeichen nicht überschreiten",
			EmailBlank: "^E-Mail darf nicht leer sein",
			EmailFormat: "^E-Mail ist keine gültige E-Mail",
			PasswordBlank: "^Passwort darf nicht leer sein",
			PasswordFormat: "^Passwort ist ungültig",
			PasswordConfirmationBlank: "^Passwortbestätigung darf nicht leer sein",
			PasswordConfirmationNotEqual: "^Passwortbestätigung ist nicht gleich Passwort",
			TitleBlank: "^Titel darf nicht leer sein",
			DoctorSpecialtyBlank: "^Das Fachgebiet des Arztes darf nicht leer sein",
			FirstNameBlank: "^Der Vorname darf nicht leer sein",
			FirstNameTooLong: "^Der Vorname darf {max} Zeichen nicht überschreiten",
			FirstNameFormat: "^Der Vorname darf nicht in Groß- oder Kleinbuchstaben geschrieben werden",
			LastNameBlank: "^Nachname darf nicht leer sein",
			LastNameTooLong: "^Der Nachname darf {max} Zeichen nicht überschreiten",
			LastNameFormat: "^Der Nachname darf nicht in Groß- oder Kleinbuchstaben geschrieben werden",
			PreferredNameFormat: "^Bevorzugter Name darf nicht nur in Groß- oder Kleinbuchstaben geschrieben werden",
			CustomerWebsiteFormat: "^Link zur Kunden-Website ungültig. Bitte stellen Sie sicher, dass Sie http:// oder https:// in die URL einschließen.",
			OfficeContactEmailFormat: "^Die E-Mail-Adresse des Bürokontakts ist keine gültige E-Mail.",
			OfficePhoneBlank: "^Bürotelefon darf nicht leer sein",
			OfficeAddress1Blank: "^Büroadressenzeile 1 darf nicht leer sein",
			OfficeAddressCityBlank: "^Die Stadt der Büroadresse darf nicht leer sein",
			OfficeAddressCityFormat: "^Die Stadt der Büroadresse darf nicht in Groß- oder Kleinbuchstaben geschrieben werden",
			OfficeAddressCountryBlank: "^Das Land der Büroadresse darf nicht leer sein",
			OfficeAddressStateBlank: "^Der Status der Büroadresse darf nicht leer sein",
			OfficeAddressRegionBlank: "^Die Region der Büroadresse darf nicht leer sein",
			OfficeAddressRegionFormat: "^Die Region der Büroadresse darf nicht ausschließlich in Groß- oder Kleinbuchstaben geschrieben werden",
			OfficeAddressZipBlank: "^Die Postleitzahl der Büroadresse darf nicht leer sein",
			BillingAddressFirstNameBlank: "^Der Vorname der Rechnungsadresse darf nicht leer sein",
			BillingAddressFirstNameFormat: "^Der Vorname der Rechnungsadresse darf nicht in Groß- oder Kleinbuchstaben geschrieben werden",
			BillingAddressLastNameBlank: "^Der Nachname der Rechnungsadresse darf nicht leer sein",
			BillingAddressLastNameFormat: "^Der Nachname der Rechnungsadresse darf nicht in Groß- oder Kleinbuchstaben geschrieben werden",
			BillingAddress1Blank: "^Rechnungsadresse Zeile 1 darf nicht leer sein",
			BillingAddressCityBlank: "^Stadt der Rechnungsadresse darf nicht leer sein",
			BillingAddressCityFormat: "^Die Stadt der Rechnungsadresse darf nicht nur in Groß- oder Kleinbuchstaben geschrieben werden",
			BillingAddressCountryBlank: "^Das Land der Rechnungsadresse darf nicht leer sein",
			BillingAddressStateBlank: "^Der Status der Rechnungsadresse darf nicht leer sein",
			BillingAddressRegionBlank: "^Die Region der Rechnungsadresse darf nicht leer sein",
			BillingAddressRegionFormat: "^Die Stadt der Rechnungsadresse darf nicht nur in Groß- oder Kleinbuchstaben geschrieben werden",
			BillingAddressZipBlank: "^Die Postleitzahl der Rechnungsadresse darf nicht leer sein",
			ShippingAddressFirstNameBlank: "^Der Vorname der Lieferadresse darf nicht leer sein",
			ShippingAddressFirstNameFormat: "^Der Vorname der Lieferadresse darf nicht in Groß- oder Kleinbuchstaben geschrieben werden",
			ShippingAddressLastNameBlank: "^Der Nachname der Lieferadresse darf nicht leer sein",
			ShippingAddressLastNameFormat: "^Der Nachname der Lieferadresse darf nicht in Groß- oder Kleinbuchstaben geschrieben werden",
			ShippingAddress1Blank: "^Lieferadresse Zeile 1 darf nicht leer sein",
			ShippingAddressCityBlank: "^Die Lieferadresse darf nicht leer sein",
			ShippingAddressCityFormat: "^Lieferadresse Stadt kann nicht nur in Groß- oder Kleinschreibung sein",
			ShippingAddressCountryBlank: "^Lieferadresse Land darf nicht leer sein",
			ShippingAddressStateBlank: "^Der Status der Lieferadresse darf nicht leer sein",
			ShippingAddressRegionBlank: "^Die Region der Lieferadresse darf nicht leer sein",
			ShippingAddressRegionFormat: "^Lieferadresse Stadt kann nicht nur in Groß- oder Kleinschreibung sein",
			ShippingAddressZipBlank: "^Die Postleitzahl der Lieferadresse darf nicht leer sein",
			PrivacyPolicyUnaccepted: "^Die Datenschutzerklärung muss akzeptiert werden, um fortzufahren"
		},
		hi: {
			UsernameBlank: "^उपयोगकर्ता नाम खाली नहीं हो सकता",
			UsernameFormat: "^उपयोगकर्ता का नाम अमान्य है",
			UsernameTooLong: "^उपयोगकर्ता नाम {max} वर्णों से अधिक नहीं हो सकता",
			EmailBlank: "^ईमेल खाली नहीं हो सकता",
			EmailFormat: "^ईमेल मान्य ईमेल नहीं है",
			PasswordBlank: "^पासवर्ड खाली नहीं हो सकता",
			PasswordFormat: "^पासवर्ड गलत है",
			PasswordConfirmationBlank: "^पासवर्ड पुष्टिकरण रिक्त नहीं हो सकता",
			PasswordConfirmationNotEqual: "^पासवर्ड पुष्टिकरण पासवर्ड के बराबर नहीं है",
			TitleBlank: "^शीर्षक खाली नहीं हो सकता",
			DoctorSpecialtyBlank: "^डॉक्टर विशेषता खाली नहीं हो सकती",
			FirstNameBlank: "^पहला नाम खाली नहीं हो सकता",
			FirstNameTooLong: "^प्रथम नाम {max} वर्णों से अधिक नहीं हो सकता",
			FirstNameFormat: "^पहला नाम सभी अपर या लोअर केस नहीं हो सकता",
			LastNameBlank: "^उपनाम खाली नहीं हो सकता",
			LastNameTooLong: "^उपनाम {max} वर्णों से अधिक नहीं हो सकता",
			LastNameFormat: "^उपनाम सभी अपर या लोअर केस नहीं हो सकता",
			PreferredNameFormat: "^पसंदीदा नाम सभी अपर या लोअर केस नहीं हो सकता",
			CustomerWebsiteFormat: "^ग्राहक वेबसाइट लिंक अमान्य है। कृपया सुनिश्चित करें कि आपने url में http:// या https:// शामिल किया है।",
			OfficeContactEmailFormat: "^कार्यालय संपर्क ईमेल मान्य ईमेल नहीं है",
			OfficePhoneBlank: "^कार्यालय का फ़ोन खाली नहीं हो सकता",
			OfficeAddress1Blank: "^कार्यालय का पता पंक्ति 1 रिक्त नहीं हो सकता",
			OfficeAddressCityBlank: "^कार्यालय का पता शहर खाली नहीं हो सकता",
			OfficeAddressCityFormat: "^कार्यालय का पता शहर सभी अपर या लोअर केस का नहीं हो सकता",
			OfficeAddressCountryBlank: "^कार्यालय का पता देश खाली नहीं हो सकता",
			OfficeAddressStateBlank: "^कार्यालय के पते की स्थिति खाली नहीं हो सकती",
			OfficeAddressRegionBlank: "^कार्यालय का पता क्षेत्र खाली नहीं हो सकता",
			OfficeAddressRegionFormat: "^कार्यालय का पता क्षेत्र सभी अपर या लोअर केस का नहीं हो सकता",
			OfficeAddressZipBlank: "^कार्यालय का पता ज़िप खाली नहीं हो सकता",
			BillingAddressFirstNameBlank: "^बिलिंग पता प्रथम नाम खाली नहीं हो सकता",
			BillingAddressFirstNameFormat: "^बिलिंग पता प्रथम नाम सभी अपर या लोअर केस नहीं हो सकता",
			BillingAddressLastNameBlank: "^बिलिंग पता अंतिम नाम खाली नहीं हो सकता",
			BillingAddressLastNameFormat: "^बिलिंग पता अंतिम नाम सभी अपर या लोअर केस नहीं हो सकता",
			BillingAddress1Blank: "^बिलिंग पता पंक्ति 1 रिक्त नहीं हो सकती",
			BillingAddressCityBlank: "^बिलिंग पता शहर खाली नहीं हो सकता",
			BillingAddressCityFormat: "^बिलिंग पता शहर सभी अपर या लोअर केस का नहीं हो सकता",
			BillingAddressCountryBlank: "^बिलिंग पता देश खाली नहीं हो सकता",
			BillingAddressStateBlank: "^बिलिंग पता स्थिति खाली नहीं हो सकती",
			BillingAddressRegionBlank: "^बिलिंग पता क्षेत्र खाली नहीं हो सकता",
			BillingAddressRegionFormat: "^बिलिंग पता शहर सभी अपर या लोअर केस का नहीं हो सकता",
			BillingAddressZipBlank: "^बिलिंग पता ज़िप खाली नहीं हो सकता",
			ShippingAddressFirstNameBlank: "^शिपिंग पता पहला नाम खाली नहीं हो सकता",
			ShippingAddressFirstNameFormat: "^शिपिंग पता पहला नाम सभी अपर या लोअर केस का नहीं हो सकता",
			ShippingAddressLastNameBlank: "^शिपिंग पता अंतिम नाम खाली नहीं हो सकता",
			ShippingAddressLastNameFormat: "^शिपिंग पता अंतिम नाम सभी अपर या लोअर केस नहीं हो सकता",
			ShippingAddress1Blank: "^शिपिंग पता पंक्ति 1 खाली नहीं हो सकती",
			ShippingAddressCityBlank: "^शिपिंग पता शहर खाली नहीं हो सकता",
			ShippingAddressCityFormat: "^शिपिंग पता शहर सभी अपर या लोअर केस का नहीं हो सकता",
			ShippingAddressCountryBlank: "^शिपिंग पता देश खाली नहीं हो सकता",
			ShippingAddressStateBlank: "^शिपिंग पता स्थिति खाली नहीं हो सकती",
			ShippingAddressRegionBlank: "^शिपिंग पता क्षेत्र खाली नहीं हो सकता",
			ShippingAddressRegionFormat: "^शिपिंग पता शहर सभी अपर या लोअर केस का नहीं हो सकता",
			ShippingAddressZipBlank: "^शिपिंग पता ज़िप खाली नहीं हो सकता",
			PrivacyPolicyUnaccepted: "^जारी रखने के लिए गोपनीयता नीति को स्वीकार किया जाना चाहिए"
		},
		ru: {
			UsernameBlank: "^Имя пользователя не может быть пустым",
			UsernameFormat: "^Имя пользователя недействительно",
			UsernameTooLong: "^Имя пользователя не может содержать более {max} символа.",
			EmailBlank: "^Электронная почта не может быть пустым",
			EmailFormat: "^Электронная почта недействительна",
			PasswordBlank: "^Пароль не может быть пустым",
			PasswordFormat: "^Неправильный пароль",
			PasswordConfirmationBlank: "^Подтверждение пароля не может быть пустым",
			PasswordConfirmationNotEqual: "^Подтверждение пароля не равно паролю",
			TitleBlank: "^Заголовок не может быть пустым",
			DoctorSpecialtyBlank: "^Специальность врача не может быть пустым",
			FirstNameBlank: "^Имя не может быть пустым",
			FirstNameTooLong: "^Имя не может содержать более {max} символов.",
			FirstNameFormat: "^Имя не может быть полностью прописным или строчным.",
			LastNameBlank: "^Фамилия не может быть пустым",
			LastNameTooLong: "^Фамилия не может превышать {max} символов.",
			LastNameFormat: "^Фамилия не может быть полностью прописной или строчной.",
			PreferredNameFormat: "^Предпочтительное имя не может быть полностью прописным или строчным.",
			CustomerWebsiteFormat: "^Ссылка на веб-сайт клиента недействительна. Убедитесь, что вы включили http: // или https: // в URL-адрес.",
			OfficeContactEmailFormat: "^Контактный адрес электронной почты офиса не является действительным",
			OfficePhoneBlank: "^Рабочий телефон не может быть пустым",
			OfficeAddress1Blank: "^Строка адреса офиса 1 не может быть пустой.",
			OfficeAddressCityBlank: "^Город адреса офиса не может быть пустым",
			OfficeAddressCityFormat: "^Город адреса офиса не может быть полностью прописным или строчным.",
			OfficeAddressCountryBlank: "^Страна адреса офиса не может быть пустым",
			OfficeAddressStateBlank: "^Адрес офиса не может быть пустым",
			OfficeAddressRegionBlank: "^Область адреса офиса не может быть пустым",
			OfficeAddressRegionFormat: "^Область адреса офиса не может быть полностью прописной или строчной.",
			OfficeAddressZipBlank: "^Почтовый индекс офиса не может быть пустым",
			BillingAddressFirstNameBlank: "^Имя платежного адреса не может быть пустым",
			BillingAddressFirstNameFormat: "^Имя платежного адреса не может быть полностью или прописным.",
			BillingAddressLastNameBlank: "^Фамилия платежного адреса не может быть пустым",
			BillingAddressLastNameFormat: "^Фамилия платежного адреса не может быть полностью прописной или строчной.",
			BillingAddress1Blank: "^Строка платежного адреса 1 не может быть пустой.",
			BillingAddressCityBlank: "^Город платежного адреса не может быть пустым.",
			BillingAddressCityFormat: "^Город платежного адреса не может быть полностью прописным или строчным.",
			BillingAddressCountryBlank: "^Укажите страну платежного адреса.",
			BillingAddressStateBlank: "^Состояние платежного адреса не может быть пустым.",
			BillingAddressRegionBlank: "^Регион платежного адреса не может быть пустым.",
			BillingAddressRegionFormat: "^Город платежного адреса не может быть полностью прописным или строчным.",
			BillingAddressZipBlank: "^Почтовый индекс платежного адреса не может быть пустым.",
			ShippingAddressFirstNameBlank: "^Имя адреса доставки не может быть пустым",
			ShippingAddressFirstNameFormat: "^Имя адреса доставки не может быть полностью или прописным.",
			ShippingAddressLastNameBlank: "^Фамилия адреса доставки не может быть пустым",
			ShippingAddressLastNameFormat: "^Фамилия адреса доставки не может быть полностью прописной или строчной.",
			ShippingAddress1Blank: "^Строка адреса доставки 1 не может быть пустой.",
			ShippingAddressCityBlank: "^Город доставки не может быть пустым",
			ShippingAddressCityFormat: "^Город доставки не может быть полностью или прописным.",
			ShippingAddressCountryBlank: "^Страна доставки не может быть пустым",
			ShippingAddressStateBlank: "^Укажите адрес доставки.",
			ShippingAddressRegionBlank: "^Регион адреса доставки не может быть пустым",
			ShippingAddressRegionFormat: "^Город доставки не может быть полностью или прописным.",
			ShippingAddressZipBlank: "^Почтовый индекс адреса доставки не может быть пустым",
			PrivacyPolicyUnaccepted: "^Чтобы продолжить, необходимо принять политику конфиденциальности."
		},
		es: {
			UsernameBlank: "^El nombre de usuario no puede estar en blanco",
			UsernameFormat: "^Nombre de usuario invalido",
			UsernameTooLong: "^El nombre de usuario no puede superar los {max} caracteres",
			EmailBlank: "^El correo electrónico no puede estar en blanco",
			EmailFormat: "^El correo electrónico no es válido.",
			PasswordBlank: "^La contraseña no puede estar en blanco",
			PasswordFormat: "^La contraseña no es válida",
			PasswordConfirmationBlank: "^La confirmación de la contraseña no puede estar en blanco",
			PasswordConfirmationNotEqual: "^La confirmación de la contraseña no es igual a la contraseña",
			TitleBlank: "^El título no puede estar en blanco",
			DoctorSpecialtyBlank: "^La especialidad del médico no puede estar en blanco",
			FirstNameBlank: "^El nombre no puede estar en blanco",
			FirstNameTooLong: "^El nombre no puede superar los {max} caracteres",
			FirstNameFormat: "^El nombre no puede estar todo en mayúsculas o minúsculas",
			LastNameBlank: "^El apellido no puede estar en blanco",
			LastNameTooLong: "^El apellido no puede superar los {max} caracteres",
			LastNameFormat: "^El apellido no puede estar todo en mayúsculas o minúsculas",
			PreferredNameFormat: "^El nombre preferido no puede ser todo en mayúsculas o minúsculas",
			CustomerWebsiteFormat: "^El enlace al sitio web del cliente no es válido. Asegúrese de incluir http: // o https: // en la URL.",
			OfficeContactEmailFormat: "^El correo electrónico de contacto de Office no es válido",
			OfficePhoneBlank: "^El teléfono de la oficina no puede estar en blanco",
			OfficeAddress1Blank: "^La línea 1 de la dirección de la oficina no puede estar en blanco",
			OfficeAddressCityBlank: "^La ciudad de la dirección de la oficina no puede estar en blanco",
			OfficeAddressCityFormat: "^La ciudad de la dirección de la oficina no puede estar en mayúsculas o minúsculas",
			OfficeAddressCountryBlank: "^El país de la dirección de la oficina no puede estar en blanco",
			OfficeAddressStateBlank: "^El estado de la dirección de la oficina no puede estar en blanco",
			OfficeAddressRegionBlank: "^La región de la dirección de la oficina no puede estar en blanco",
			OfficeAddressRegionFormat: "^La región de la dirección de la oficina no puede estar en mayúsculas o minúsculas",
			OfficeAddressZipBlank: "^El código postal de la dirección de la oficina no puede estar en blanco",
			BillingAddressFirstNameBlank: "^El nombre de la dirección de facturación no puede estar en blanco",
			BillingAddressFirstNameFormat: "^El nombre de la dirección de facturación no puede estar todo en mayúsculas o minúsculas",
			BillingAddressLastNameBlank: "^El apellido de la dirección de facturación no puede dejarse en blanco",
			BillingAddressLastNameFormat: "^El apellido de la dirección de facturación no puede estar todo en mayúsculas o minúsculas",
			BillingAddress1Blank: "^La línea 1 de la dirección de facturación no puede estar en blanco",
			BillingAddressCityBlank: "^La ciudad de la dirección de facturación no puede estar en blanco",
			BillingAddressCityFormat: "^La ciudad de la dirección de facturación no puede estar en mayúsculas o minúsculas",
			BillingAddressCountryBlank: "^El país de la dirección de facturación no puede dejarse en blanco",
			BillingAddressStateBlank: "^El estado de la dirección de facturación no puede dejarse en blanco",
			BillingAddressRegionBlank: "^La región de la dirección de facturación no puede estar en blanco",
			BillingAddressRegionFormat: "^La ciudad de la dirección de facturación no puede estar en mayúsculas o minúsculas",
			BillingAddressZipBlank: "^El código postal de la dirección de facturación no puede estar en blanco",
			ShippingAddressFirstNameBlank: "^El nombre de la dirección de envío no puede estar en blanco",
			ShippingAddressFirstNameFormat: "^El nombre de la dirección de envío no puede estar todo en mayúsculas o minúsculas",
			ShippingAddressLastNameBlank: "^El apellido de la dirección de envío no puede estar en blanco",
			ShippingAddressLastNameFormat: "^El apellido de la dirección de envío no puede estar todo en mayúsculas o minúsculas",
			ShippingAddress1Blank: "^La línea 1 de la dirección de envío no puede estar en blanco",
			ShippingAddressCityBlank: "^La ciudad de la dirección de envío no puede estar en blanco",
			ShippingAddressCityFormat: "^La ciudad de la dirección de envío no puede estar en mayúsculas o minúsculas",
			ShippingAddressCountryBlank: "^El país de la dirección de envío no puede estar en blanco",
			ShippingAddressStateBlank: "^El estado de la dirección de envío no puede estar en blanco",
			ShippingAddressRegionBlank: "^La región de la dirección de envío no puede estar en blanco",
			ShippingAddressRegionFormat: "^La ciudad de la dirección de envío no puede estar en mayúsculas o minúsculas",
			ShippingAddressZipBlank: "^El código postal de la dirección de envío no puede estar en blanco",
			PrivacyPolicyUnaccepted: "^Se debe aceptar la política de privacidad para continuar"
		},
		da: {
			UsernameBlank: "^Brugernavn må ikke være tomt",
			UsernameFormat: "^Brugernavn er ugyldigt",
			UsernameTooLong: "^Brugernavn kan ikke overstige {MAX} tegn",
			EmailBlank: "^Email kan ikke være tom",
			EmailFormat: "^Email er ikke en gyldig email",
			PasswordBlank: "^Adgangskoden kan ikke være tom",
			PasswordFormat: "^Adgangskoden er ugyldig",
			PasswordConfirmationBlank: "^Adgangskode bekræftelse kan ikke være tom",
			PasswordConfirmationNotEqual: "^Adgangskode bekræftelse er ikke lig med adgangskode",
			TitleBlank: "^Titel kan ikke være tomt",
			DoctorSpecialtyBlank: "^Læge specialitet kan ikke være tom",
			FirstNameBlank: "^Fornavn kan ikke være tomt",
			FirstNameTooLong: "^Fornavn kan ikke overstige {MAX} tegn",
			FirstNameFormat: "^Fornavn kan ikke være helt øverste eller små bogstaver",
			LastNameBlank: "^Efternavn kan ikke være tomt",
			LastNameTooLong: "^Efternavn kan ikke overstige {MAX} tegn",
			LastNameFormat: "^Efternavn kan ikke være helt øverste eller små bogstaver",
			PreferredNameFormat: "^Foretrukket navn kan ikke være helt øverste eller små bogstaver",
			CustomerWebsiteFormat: "^Kundewebsted link ugyldig. Sørg for, at du inkludere http: // eller https: // i webadressen.",
			OfficeContactEmailFormat: "^Office Kontakt Email er ikke en gyldig email",
			OfficePhoneBlank: "^Kontor telefon kan ikke være tom",
			OfficeAddress1Blank: "^Office Adresse Line 1 kan ikke være tom",
			OfficeAddressCityBlank: "^Kontoradressebyen kan ikke være tom",
			OfficeAddressCityFormat: "^Kontoradressebyen kan ikke være helt øverste eller små bogstaver",
			OfficeAddressCountryBlank: "^Kontoradresselandet kan ikke være tomt",
			OfficeAddressStateBlank: "^Kontoradresse Staten kan ikke være tom",
			OfficeAddressRegionBlank: "^Kontoradresse regionen kan ikke være tomt",
			OfficeAddressRegionFormat: "^Kontoradresse regionen kan ikke være helt øverste eller små bogstaver",
			OfficeAddressZipBlank: "^Kontoradresse ZIP kan ikke være tomt",
			BillingAddressFirstNameBlank: "^Faktureringsadresse Fornavn kan ikke være tomt",
			BillingAddressFirstNameFormat: "^Faktureringsadresse Fornavn kan ikke være helt øverste eller små bogstaver",
			BillingAddressLastNameBlank: "^Faktureringsadresse Efternavn kan ikke være tomt",
			BillingAddressLastNameFormat: "^Faktureringsadresse Efternavn kan ikke være helt øverste eller små bogstaver",
			BillingAddress1Blank: "^Faktureringsadresse linje 1 kan ikke være tom",
			BillingAddressCityBlank: "^Faktureringsadressebyen kan ikke være tom",
			BillingAddressCityFormat: "^Faktureringsadressebyen kan ikke være helt øverste eller små bogstaver",
			BillingAddressCountryBlank: "^Faktureringsadresselandet kan ikke være tomt",
			BillingAddressStateBlank: "^Faktureringsadresse Staten kan ikke være tom",
			BillingAddressRegionBlank: "^Faktureringsadresse regionen kan ikke være tomt",
			BillingAddressRegionFormat: "^Faktureringsadressebyen kan ikke være helt øverste eller små bogstaver",
			BillingAddressZipBlank: "^Faktureringsadresse ZIP kan ikke være tom",
			ShippingAddressFirstNameBlank: "^Forsendelsesadresse Fornavn kan ikke være tomt",
			ShippingAddressFirstNameFormat: "^Forsendelsesadresse Fornavn kan ikke være helt øverste eller små bogstaver",
			ShippingAddressLastNameBlank: "^Forsendelsesadresse Efternavn kan ikke være tomt",
			ShippingAddressLastNameFormat: "^Forsendelsesadresse Efternavn kan ikke være helt øverste eller små bogstaver",
			ShippingAddress1Blank: "^Forsendelsesadresse linje 1 kan ikke være tom",
			ShippingAddressCityBlank: "^Forsendelsesadressebyen kan ikke være tom",
			ShippingAddressCityFormat: "^Forsendelsesadressebyen kan ikke være helt øverste eller små bogstaver",
			ShippingAddressCountryBlank: "^Forsendelsesadresselandet kan ikke være tomt",
			ShippingAddressStateBlank: "^Forsendelsesadresse Staten kan ikke være tom",
			ShippingAddressRegionBlank: "^Forsendelsesadresse regionen kan ikke være tomt",
			ShippingAddressRegionFormat: "^Forsendelsesadressebyen kan ikke være helt øverste eller små bogstaver",
			ShippingAddressZipBlank: "^Forsendelsesadresse ZIP kan ikke være tom",
			PrivacyPolicyUnaccepted: "^Fortrolighedspolitik skal accepteres for at fortsætte"
		},
		nl: {
			UsernameBlank: "^Gebruikersnaam mag niet leeg zijn",
			UsernameFormat: "^Gebruikersnaam is ongeldig",
			UsernameTooLong: "^Gebruikersnaam kan niet overschrijden {max} tekens",
			EmailBlank: "^E-mail kan niet leeg zijn",
			EmailFormat: "^E-mail is geen geldige e-mail",
			PasswordBlank: "^Wachtwoord kan niet leeg zijn",
			PasswordFormat: "^Wachtwoord is ongeldig",
			PasswordConfirmationBlank: "^Wachtwoordbevestiging kan niet leeg zijn",
			PasswordConfirmationNotEqual: "^Wachtwoordbevestiging is niet gelijk aan wachtwoord",
			TitleBlank: "^Titel kan niet leeg zijn",
			DoctorSpecialtyBlank: "^Arts Speciality kan niet leeg zijn",
			FirstNameBlank: "^Voornaam kan niet leeg zijn",
			FirstNameTooLong: "^Voornaam kan niet overschrijden {MAX} -karakters",
			FirstNameFormat: "^Voornaam kan niet alle bovenste of kleine letters zijn",
			LastNameBlank: "^Achternaam kan niet leeg zijn",
			LastNameTooLong: "^Achternaam kan niet overschrijden {MAX} -tekens",
			LastNameFormat: "^Achternaam kan niet alle bovenste of kleine letters zijn",
			PreferredNameFormat: "^Voorkeursnaam kan niet alle bovenste of kleine letters zijn",
			CustomerWebsiteFormat: "^Klantwebsite link ongeldig. Zorg ervoor dat u http: // of https opneemt: // in de URL.",
			OfficeContactEmailFormat: "^Kantoorcontact-e-mail is geen geldige e-mail",
			OfficePhoneBlank: "^Office-telefoon kan niet leeg zijn",
			OfficeAddress1Blank: "^Office-adresregel 1 kan niet leeg zijn",
			OfficeAddressCityBlank: "^Kantooradresstad kan niet leeg zijn",
			OfficeAddressCityFormat: "^Kantooradresstad kan niet alle bovenste of kleine letters zijn",
			OfficeAddressCountryBlank: "^Office-adresland kan niet leeg zijn",
			OfficeAddressStateBlank: "^Office-adresstatus kan niet leeg zijn",
			OfficeAddressRegionBlank: "^Kantooradresregio kan niet leeg zijn",
			OfficeAddressRegionFormat: "^Office-adresregio kan niet alle bovenste of kleine letters zijn",
			OfficeAddressZipBlank: "^Office Adres Zip kan niet leeg zijn",
			BillingAddressFirstNameBlank: "^Factuuradres Voornaam kan niet leeg zijn",
			BillingAddressFirstNameFormat: "^Factuuradres Voornaam kan niet alle bovenste of kleine letters zijn",
			BillingAddressLastNameBlank: "^Factuuradres achternaam kan niet leeg zijn",
			BillingAddressLastNameFormat: "^Factuuradres achternaam kan niet alle bovenste of kleine letters zijn",
			BillingAddress1Blank: "^Factuuradresregel 1 kan niet leeg zijn",
			BillingAddressCityBlank: "^Factuuradres City kan niet leeg zijn",
			BillingAddressCityFormat: "^Facturatieadresstad kan niet alle bovenste of kleine letters zijn",
			BillingAddressCountryBlank: "^Facturatie-adresland kan niet leeg zijn",
			BillingAddressStateBlank: "^Factuuradresstatus kan niet leeg zijn",
			BillingAddressRegionBlank: "^Factuuradresregio kan niet leeg zijn",
			BillingAddressRegionFormat: "^Facturatieadresstad kan niet alle bovenste of kleine letters zijn",
			BillingAddressZipBlank: "^Factuuradres Zip kan niet leeg zijn",
			ShippingAddressFirstNameBlank: "^Verzendadres Voornaam kan niet leeg zijn",
			ShippingAddressFirstNameFormat: "^Verzendadres Voornaam kan niet alle bovenste of kleine letters zijn",
			ShippingAddressLastNameBlank: "^Verzendadres Achternaam kan niet leeg zijn",
			ShippingAddressLastNameFormat: "^Achternaam verzendadres kan niet alle bovenste of kleine letters zijn",
			ShippingAddress1Blank: "^Verzendadresregel 1 kan niet leeg zijn",
			ShippingAddressCityBlank: "^Shipping Address City kan niet leeg zijn",
			ShippingAddressCityFormat: "^Verzendadresstad kan niet alle bovenste of kleine letters zijn",
			ShippingAddressCountryBlank: "^Verzendadres Land kan niet leeg zijn",
			ShippingAddressStateBlank: "^Verzendadresstatus kan niet leeg zijn",
			ShippingAddressRegionBlank: "^Verzendadresregio kan niet leeg zijn",
			ShippingAddressRegionFormat: "^Verzendadresstad kan niet alle bovenste of kleine letters zijn",
			ShippingAddressZipBlank: "^Verzendadres Zip kan niet leeg zijn",
			PrivacyPolicyUnaccepted: "^Privacybeleid moet worden aanvaard om door te gaan"
		},
		it: {
			UsernameBlank: "^Il nome utente non può essere vuoto",
			UsernameFormat: "^L'username non è valido",
			UsernameTooLong: "^Il nome utente non può superare i caratteri {max}",
			EmailBlank: "^L'e-mail non può essere vuota",
			EmailFormat: "^L'email non è un'e-mail valida",
			PasswordBlank: "^La password non può essere vuota",
			PasswordFormat: "^La password non è valida",
			PasswordConfirmationBlank: "^La conferma della password non può essere vuota",
			PasswordConfirmationNotEqual: "^La conferma della password non è uguale alla password",
			TitleBlank: "^Il titolo non può essere vuoto",
			DoctorSpecialtyBlank: "^La specialità del dottore non può essere vuota",
			FirstNameBlank: "^Il nome non può essere vuoto",
			FirstNameTooLong: "^Il nome non può superare i caratteri {max}",
			FirstNameFormat: "^Il nome non può essere tutto maiuscolo o minuscolo",
			LastNameBlank: "^Il cognome non può essere vuoto",
			LastNameTooLong: "^Il cognome non può superare i caratteri {max}",
			LastNameFormat: "^Il cognome non può essere tutto maiuscolo o minuscolo",
			PreferredNameFormat: "^Il nome preferito non può essere mai maiuscolo o minuscolo",
			CustomerWebsiteFormat: "^Il collegamento del sito web del cliente non è valido. Assicurati di includere http: // o https: // nell'URL.",
			OfficeContactEmailFormat: "^L'email del contatto dell'ufficio non è un'e-mail valida",
			OfficePhoneBlank: "^Il telefono dell'ufficio non può essere vuoto",
			OfficeAddress1Blank: "^La linea 1 dell'ufficio non può essere vuota",
			OfficeAddressCityBlank: "^L'indirizzo dell'ufficio City non può essere vuoto",
			OfficeAddressCityFormat: "^L'indirizzo dell'ufficio La città non può essere mai maiuscola o inferiore",
			OfficeAddressCountryBlank: "^Il paese degli indirizzi dell'ufficio non può essere vuoto",
			OfficeAddressStateBlank: "^Lo stato di indirizzo dell'ufficio non può essere vuoto",
			OfficeAddressRegionBlank: "^La regione degli indirizzi dell'ufficio non può essere vuota",
			OfficeAddressRegionFormat: "^La regione dell'indirizzo dell'ufficio non può essere mai maiuscola o inferiore",
			OfficeAddressZipBlank: "^L'indirizzo dell'ufficio la zip non può essere vuoto",
			BillingAddressFirstNameBlank: "^Indirizzo di fatturazione Nome non può essere vuoto",
			BillingAddressFirstNameFormat: "^Il nome dell'indirizzo di fatturazione non può essere tutto maiuscolo o minuscolo",
			BillingAddressLastNameBlank: "^Il cognome degli indirizzi di fatturazione non può essere vuoto",
			BillingAddressLastNameFormat: "^Il cognome degli indirizzi di fatturazione non può essere mai maiuscolo o minuscolo",
			BillingAddress1Blank: "^La linea di indirizzo di fatturazione 1 non può essere vuota",
			BillingAddressCityBlank: "^L'indirizzo di fatturazione City non può essere vuoto",
			BillingAddressCityFormat: "^La città degli indirizzi di fatturazione non può essere mai maiuscola o minuscola",
			BillingAddressCountryBlank: "^Il paese degli indirizzi di fatturazione non può essere vuoto",
			BillingAddressStateBlank: "^Lo stato degli indirizzi di fatturazione non può essere vuoto",
			BillingAddressRegionBlank: "^La regione degli indirizzi di fatturazione non può essere vuota",
			BillingAddressRegionFormat: "^La città degli indirizzi di fatturazione non può essere mai maiuscola o minuscola",
			BillingAddressZipBlank: "^L'indirizzo di fatturazione zip non può essere vuoto",
			ShippingAddressFirstNameBlank: "^Indirizzo di spedizione Il primo nome non può essere vuoto",
			ShippingAddressFirstNameFormat: "^Indirizzo di spedizione Il nome del primo nome non può essere mai maiuscolo o minuscolo",
			ShippingAddressLastNameBlank: "^Indirizzo di spedizione Cognome non può essere vuoto",
			ShippingAddressLastNameFormat: "^L'indirizzo di spedizione Cognome non può essere tutto maiuscolo o minuscolo",
			ShippingAddress1Blank: "^La linea di indirizzo 1 non può essere vuota",
			ShippingAddressCityBlank: "^L'indirizzo di spedizione Città non può essere vuoto",
			ShippingAddressCityFormat: "^L'indirizzo di spedizione Città non può essere tutto maiuscolo o minuscolo",
			ShippingAddressCountryBlank: "^Il paese di indirizzo di spedizione non può essere vuoto",
			ShippingAddressStateBlank: "^Lo stato degli indirizzi di spedizione non può essere vuoto",
			ShippingAddressRegionBlank: "^L'indirizzo di spedizione La regione non può essere vuota",
			ShippingAddressRegionFormat: "^L'indirizzo di spedizione Città non può essere tutto maiuscolo o minuscolo",
			ShippingAddressZipBlank: "^L'indirizzo di spedizione zip non può essere vuoto",
			PrivacyPolicyUnaccepted: "^La politica sulla privacy deve essere accettata per continuare"
		},
		ja: {
			UsernameBlank: "^ユーザー名を空白にすることはできません",
			UsernameFormat: "^ユーザー名が無効です",
			UsernameTooLong: "^ユーザー名は{max}文字を超えることはできません",
			EmailBlank: "^電子メールは空白にすることはできません",
			EmailFormat: "^電子メールは有効なEメールではありません",
			PasswordBlank: "^パスワードを空白にすることはできません",
			PasswordFormat: "^パスワードは無効です",
			PasswordConfirmationBlank: "^パスワードの確認は空白にすることはできません",
			PasswordConfirmationNotEqual: "^パスワードの確認はパスワードと等しくありません",
			TitleBlank: "^タイトルは空白にすることはできません",
			DoctorSpecialtyBlank: "^医師の専門小は空白にすることはできません",
			FirstNameBlank: "^ファーストネームは空白にすることはできません",
			FirstNameTooLong: "^ファーストネームは{max}文字を超えることはできません",
			FirstNameFormat: "^最初の名前はすべて大文字または小文字にすることはできません",
			LastNameBlank: "^姓を空白にすることはできません",
			LastNameTooLong: "^姓を超えることはできません",
			LastNameFormat: "^姓はすべて大文字または小文字にすることはできません",
			PreferredNameFormat: "^優先名前はすべて大文字または小文字にすることはできません",
			CustomerWebsiteFormat: "^カスタマーウェブサイトのリンクが無効です。 URLにhttp：//またはhttps：//を含めるようにしてください。",
			OfficeContactEmailFormat: "^オフィスの連絡先メールアドレスは有効なメールアドレスではありません",
			OfficePhoneBlank: "^オフィス電話は空白にすることはできません",
			OfficeAddress1Blank: "^オフィスの住所の1行目を空白にすることはできません",
			OfficeAddressCityBlank: "^オフィスアドレス都市は空白にすることはできません",
			OfficeAddressCityFormat: "^オフィスの住所都市をすべて大文字または小文字にすることはできません",
			OfficeAddressCountryBlank: "^オフィスアドレス国は空白にすることはできません",
			OfficeAddressStateBlank: "^オフィスの住所の状態を空白にすることはできません",
			OfficeAddressRegionBlank: "^オフィスの住所地域を空白にすることはできません",
			OfficeAddressRegionFormat: "^オフィスの住所地域をすべて大文字または小文字にすることはできません",
			OfficeAddressZipBlank: "^オフィスの住所のzipを空白にすることはできません",
			BillingAddressFirstNameBlank: "^請求先住所ファーストネームは空白にすることはできません",
			BillingAddressFirstNameFormat: "^請求先住所ファーストネームはすべて大文字または小文字にすることはできません",
			BillingAddressLastNameBlank: "^請求先住所の姓を空白にすることはできません",
			BillingAddressLastNameFormat: "^請求先住所の姓をすべて大文字または小文字にすることはできません",
			BillingAddress1Blank: "^請求先住所線1を空白にすることはできません",
			BillingAddressCityBlank: "^請求先住所シティは空白にすることはできません",
			BillingAddressCityFormat: "^請求先住所市はすべて大文字または小文字にすることはできません",
			BillingAddressCountryBlank: "^請求先住所国を空白にすることはできません",
			BillingAddressStateBlank: "^請求先住所の状態は空白にすることはできません",
			BillingAddressRegionBlank: "^請求先住所地域を空白にすることはできません",
			BillingAddressRegionFormat: "^請求先住所市はすべて大文字または小文字にすることはできません",
			BillingAddressZipBlank: "^請求先住所郵便番号を空白にすることはできません",
			ShippingAddressFirstNameBlank: "^配送先住所の姓名を空白にすることはできません",
			ShippingAddressFirstNameFormat: "^配送先住所ファーストネームはすべて大文字または小文字にすることはできません",
			ShippingAddressLastNameBlank: "^配送先住所の姓は空白にすることはできません",
			ShippingAddressLastNameFormat: "^配送先住所の姓はすべて大文字または小文字にすることはできません",
			ShippingAddress1Blank: "^配送先住所行1は空白にすることはできません",
			ShippingAddressCityBlank: "^配送先住所シティは空白にすることはできません",
			ShippingAddressCityFormat: "^配送先住所市はすべて大文字または小文字にすることはできません",
			ShippingAddressCountryBlank: "^配送先住所国を空白にすることはできません",
			ShippingAddressStateBlank: "^配送先住所の状態は空白にはできません",
			ShippingAddressRegionBlank: "^配送先住所地域は空白にすることはできません",
			ShippingAddressRegionFormat: "^配送先住所市はすべて大文字または小文字にすることはできません",
			ShippingAddressZipBlank: "^配送先住所郵便番号を空白にすることはできません",
			PrivacyPolicyUnaccepted: "^プライバシーポリシーは継続するように承認されなければなりません"
	},
		pl: {
			UsernameBlank: "^Nazwa użytkownika nie może być pusta",
			UsernameFormat: "^Nazwa użytkownika jest niepoprawna",
			UsernameTooLong: "^Nazwa użytkownika nie może przekroczyć znaków {MAX}",
			EmailBlank: "^E-mail nie może być pusty",
			EmailFormat: "^E-mail nie jest ważnym adresem e-mail",
			PasswordBlank: "^Hasło nie może być puste",
			PasswordFormat: "^Hasło jest niewłaściwe",
			PasswordConfirmationBlank: "^Potwierdzenie hasła nie może być puste",
			PasswordConfirmationNotEqual: "^Potwierdzenie hasła nie jest równe hasła",
			TitleBlank: "^Tytuł nie może być pusty",
			DoctorSpecialtyBlank: "^Specjalność lekarza nie może być pusta",
			FirstNameBlank: "^Imię nie może być puste",
			FirstNameTooLong: "^Imię nie może przekroczyć znaków {max}",
			FirstNameFormat: "^Imię nie może być wszystkimi górnymi lub małymi literami",
			LastNameBlank: "^Nazwisko nie może być puste",
			LastNameTooLong: "^Nazwisko nie może przekroczyć znaków {max}",
			LastNameFormat: "^Nazwisko nie może być wszystkie wielkie lub małe litery",
			PreferredNameFormat: "^Preferowana nazwa nie może być wszystkimi górnymi lub małymi literami",
			CustomerWebsiteFormat: "^Nieprawidłowy link witryny klienta. Upewnij się, że zawiera http: // lub https: // w adresie URL.",
			OfficeContactEmailFormat: "^Email Kontaktowy Office nie jest ważnym adresem e-mail",
			OfficePhoneBlank: "^Telefon biurowy nie może być pusty",
			OfficeAddress1Blank: "^Linia adresowa biura 1 nie może być pusta",
			OfficeAddressCityBlank: "^Miasto adresowe nie może być puste",
			OfficeAddressCityFormat: "^Miasto adresu biurowego nie może być wszystkimi górnymi lub małymi literami",
			OfficeAddressCountryBlank: "^Kraj adresów biurowych nie może być pusty",
			OfficeAddressStateBlank: "^Stan adresu biurowego nie może być pusty",
			OfficeAddressRegionBlank: "^Region adresu biurowego nie może być pusty",
			OfficeAddressRegionFormat: "^Region adresu biurowego nie może być wszystkie wielkie lub małe litery",
			OfficeAddressZipBlank: "^Zip adres biura nie może być pusty",
			BillingAddressFirstNameBlank: "^Adres rozliczeniowy Imię nie może być puste",
			BillingAddressFirstNameFormat: "^Adres rozliczeniowy Imię nie może być wszystkimi górnymi lub małymi literami",
			BillingAddressLastNameBlank: "^Adres rozliczeniowy Nazwisko nie może być puste",
			BillingAddressLastNameFormat: "^Nazwisko adresu rozliczeniowego nie może być wszystkimi górnymi lub małymi literami",
			BillingAddress1Blank: "^Linia adresu rozliczeniowego 1 nie może być pusta",
			BillingAddressCityBlank: "^Adres rozliczeniowy Miasto nie może być pusty",
			BillingAddressCityFormat: "^Miasto adresu rozliczeniowego nie może być wszystkimi górnymi lub małymi literami",
			BillingAddressCountryBlank: "^Kraj adresu rozliczeniowego nie może być pusty",
			BillingAddressStateBlank: "^Stan adresu rozliczeniowego nie może być pusty",
			BillingAddressRegionBlank: "^Region adresu rozliczeniowego nie może być pusty",
			BillingAddressRegionFormat: "^Miasto adresu rozliczeniowego nie może być wszystkimi górnymi lub małymi literami",
			BillingAddressZipBlank: "^Adres rozliczeniowy ZIP nie może być pusty",
			ShippingAddressFirstNameBlank: "^Adres wysyłki Imię nie może być puste",
			ShippingAddressFirstNameFormat: "^Adres wysyłki Imię nie może być wszystkimi górnymi lub małymi literami",
			ShippingAddressLastNameBlank: "^Adres wysyłki Nazwisko nie może być puste",
			ShippingAddressLastNameFormat: "^Adres wysyłki Nazwisko nie może być wszystkimi górnymi lub małymi literami",
			ShippingAddress1Blank: "^Linia adresu wysyłki 1 nie może być pusta",
			ShippingAddressCityBlank: "^Adres wysyłki miasto nie może być puste",
			ShippingAddressCityFormat: "^City Adres wysyłki nie może być wszystkimi górnymi lub małymi literami",
			ShippingAddressCountryBlank: "^Kraj adresów wysyłki nie może być pusty",
			ShippingAddressStateBlank: "^Stan adresu wysyłki nie może być pusty",
			ShippingAddressRegionBlank: "^Region adresu wysyłki nie może być pusty",
			ShippingAddressRegionFormat: "^City Adres wysyłki nie może być wszystkimi górnymi lub małymi literami",
			ShippingAddressZipBlank: "^Adres wysyłkowy Zip nie może być pusty",
			PrivacyPolicyUnaccepted: "^Polityka prywatności musi zostać przyjęta do kontynuowania"
		}
	};

})(jQuery, new ProfileHelper(koisCustomerProfile.template));
